import React from 'react';
import { Table } from 'semantic-ui-react';
import { connect } from 'react-redux';
import TableWrapper from '@/components/table/TableWrapper';
import { states } from '@/constants/lifecycle';
import { firstError } from '@/utils/errors';
import findResult from '@/utils/resultsHelper';
import NoRowsWrapper from '@/components/table/NoRowsWrapper';
import paging, { pagingConfig, pagingHookConfig } from '@/hooks/paging';
import UsergroupUsersTableColumns from '../components/UsergroupUsersTableColumns';
import { dismissUsergroupUsersError, fetchUserGroupUsers, removeUsergroupUser } from '../actions/usergroupUsers';
import UsergroupUsersAddRow from './UsergroupUsersAddRow';
import UsergroupUsersTableRows from '../components/UsergroupUsersTableRows';
import UsergroupUsersTableHeader from '../components/UsergroupUsersTableHeader';

const UsergroupUsersTable = ({
  allowAdd,
  allowRemove,
  category,
  code,
  dismissError,
  fetchUsers,
  isDuplicate,
  readErrors,
  readStatus,
  removeUser,
  users,
}) => {
  paging.useFetchByCode(fetchUsers, category, code, readStatus, { ...pagingHookConfig(), ...pagingConfig(10000) });
  return (
    <div className="aridhia-usergroup-users">
      <NoRowsWrapper
        entity="user"
        icon="users"
        readStatus={[readStatus]}
        items={users}
        showChildrenIfNoRows
      >
        <TableWrapper className="aridhia-usergroup-users-table" sticky>
          <UsergroupUsersTableHeader
            error={firstError(readErrors)}
            onErrorDismiss={() => dismissError(category, code)}
            readStatus={readStatus}
          >
            {allowAdd && !isDuplicate && (<UsergroupUsersAddRow category={category} code={code} />)}
            {!allowAdd && !isDuplicate && (<UsergroupUsersTableColumns allowRemove={allowRemove} />)}
          </UsergroupUsersTableHeader>
          <Table.Body>
            <UsergroupUsersTableRows
              allowRemove={allowRemove}
              category={category}
              code={code}
              isDuplicate={isDuplicate}
              items={users}
              removeUser={removeUser}
            />
          </Table.Body>
        </TableWrapper>
      </NoRowsWrapper>
    </div>
  );
};

const mapStateToProps = (
  { auth: { role: { permissions: { usergroups: { assign } } } }, userGroups: { userGroups } },
  { category, code },
) => {
  const item = findResult(userGroups, category, code) || {
    users: {
      results: [],
      readStatus: states.PENDING,
      readErrors: [],
    },
  };

  return {
    allowAdd: assign,
    allowRemove: assign,
    readErrors: item.users.readErrors,
    readStatus: item.users.readStatus,
    users: item.users.results,
  };
};

const mapDispatchToProps = {
  fetchUsers: fetchUserGroupUsers,
  removeUser: removeUsergroupUser,
  dismissError: dismissUsergroupUsersError,
};

export default connect(mapStateToProps, mapDispatchToProps)(UsergroupUsersTable);
